const IconChevronDown = () => {
  return (
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      data-testid="icon-down-chevron"
    />
  );
};

export default IconChevronDown;
